import _ from 'lodash';
import * as types from 'src/store/types';
import { qualificationCategory, quailficationRejectReasonType } from 'src/const/state/account';

import { PROMOTE_MUSIC_VALIDATE_MAP, MusicCommercialAuthorizationType, bcIdentityTypesList } from 'src/const/state/creative';
import { validatePromoteMusic } from 'src/service/creative';
import { getCreativeAuditDetail, getUserCustomerName } from 'src/service';
import { isCreativeHasIdentityWhite } from 'src/const/whiteList';


const musicQualification = {
  namespaced: true,
  state: {
    customerName: '',
    // 音乐资质送审参数
    paramFormData: {
      starling_namespace: 'module', // starling命名空间
      starling_project: 'TikTok_Ads', // starling项目
      category: qualificationCategory.musicQualification,
      pictures: [],
      content_fields: {
        song_name: {
          label: 6, // 写死，用于字段标记
          starling_key: 'module_account_qualification_songname', // 前端的多语言翻译key
          contents: [],
        },
        song_id: {
          label: 17,
          starling_key: '',
          contents: [],
        },
        singer_name: {
          label: 7,
          starling_key: 'module_account_qualification_artist',
          contents: [],
        },
        country_codes: {
          label: 1,
          starling_key: 'module_account_qualification_country',
          contents: [],
        },
        // pictures: [],
        authorization_time: {
          label: 8,
          starling_key: 'module_account_qualification_authorization_time',
          contents: [],
        },
        copyright_owner: {
          label: 10,
          starling_key: 'module_account_qualification_copyright_owner',
          contents: [],
        },
        authorization_range: {
          label: 11,
          starling_key: 'module_account_qualification_authorization_range',
          contents: [],
        },
        lyricist: {
          label: 12,
          starling_key: 'module_account_qualification_lyricist',
          contents: [],
        },
        composer: {
          label: 13,
          starling_key: 'module_account_qualification_composer',
          contents: [],
        },
        authorization_uids: {
          label: 14,
          starling_key: 'module_account_qualification_authorization_user_id',
          contents: [],
        },
        record_company: {
          label: 15,
          starling_key: 'module_account_qualification_record_company',
          contents: [],
        },
        publisher: {
          label: 16,
          starling_key: 'module_account_qualification_publisher',
          contents: [],
        },
        commercial_usage: {
          label: 18,
          starling_key: 'module_account_qualification_have_commercial_usage_rights',
          contents: [],
        },
      },
    },
  },
  getters: {},
  mutations: {
    [types.SET_CUSTOMER_NAME](state, data) {
      state.customerName = data || '';
    },
  },
  actions: {
    // 获取广告主customer name
    async getCustomerName({ state, commit }) {
      const data = await getUserCustomerName();
      const { customer_name = '' } = data;
      commit(types.SET_CUSTOMER_NAME, customer_name);
    },
    // 获取补充音乐资质列表
    async getSongList({ state, getters }, { query }) {
      const song_authorization_missing = PROMOTE_MUSIC_VALIDATE_MAP.AUTHORIZATION_MISSING;
      let songList = [];
      const {
        source = '',
        start_time = '',
        end_time = '',
        countries: countriesString = '',
        vid = '',
        creative_id = '',
        identity_id = '',
        identity_type = 0,
        identity_bc_id = '',
      } = query;


      // 创编页面跳转到资质页面，需要调用 验证音乐版权的接口，获取没有资质的音乐信息
      if (source === 'creative_ad') {
        let param = {
          start_time,
          end_time,
          countries: (countriesString || '').split(',').map(item => +item) || [],
          item_id: vid,
        };
        // 在identity白名单中并且有identity_id、identity_type参数时，提交表单时携带该参数。
        if (isCreativeHasIdentityWhite() && identity_id && identity_type !== undefined) {
          param = {
            identity_id, identity_type, ...param,
          };

          if (bcIdentityTypesList.includes(Number(identity_type))) {
            param.identity_bc_id = identity_bc_id;
          }
        }

        const res = await validatePromoteMusic(param);
        const { status = 0, music_infos = {} } = res;
        if (status === song_authorization_missing) {
          songList = [];
          Object.keys(music_infos).forEach((key) => {
            if (music_infos[key].authorization_type === MusicCommercialAuthorizationType.NOT_AUTHORIZED) {
              songList.push(music_infos[key]);
            }
          });
        }
        return songList;
      } if (source === 'reject_suggestion') {
        // 拒审理由跳转到资质页面，需要调用 获取巨神理由的接口，获取没有资质的音乐信息
        const res = await getCreativeAuditDetail({ creative_id });
        if (res.code === 0 && res.data) {
          const rejectList = res.data.creative?.info;
          const reason = rejectList.find(item => item.reason_type === quailficationRejectReasonType.MUSIC);
          const { contents = {} } = reason;
          if (contents.value_music_map) {
            songList = [];
            Object.keys(contents.value_music_map).forEach((key) => {
              if (contents.value_music_map[key].authorization_type === MusicCommercialAuthorizationType.NOT_AUTHORIZED) {
                songList.push(contents.value_music_map[key]);
              }
            });
          }
          return songList;
        }
        return songList;
      }
    },
    // 处理接口参数数据
    getQualificationParamsData({ state, getters }, { submitData = {}, originDate = {}, life_time = false }) {
      const data = _.cloneDeep(state.paramFormData);

      // 处理图片参数
      const pictures = submitData.qualificationList.map((img) => {
        if (img.response && img.response.data) {
          const data = img.response.data || {};
          return data.secret_file_id || '';
        }
        return img.secret_file_id || '';
      });
      data.pictures = pictures;

      const { content_fields } = data;
      Object.keys(content_fields).forEach((field) => {
        if (field === 'country_codes' || field === 'authorization_time') {
          content_fields[field].contents = submitData[field];
          return;
        }

        // authorization_uids通过,分割成数组
        if (field === 'authorization_uids') {
          content_fields[field].contents = submitData[field].split(',');
          return;
        }
        content_fields[field].contents = [submitData[field]];
      });

      const params = {
        ...originDate,
        ...data,
      };
      return params || {};
    },
  },
};

export default musicQualification;
